import React from "react";
import { Helmet } from "react-helmet";
import { Layout } from "~/templates/Layout";
import { colors } from "~/utils/colors";

const ReferralRecruitingAward2025EntryPage: React.FC = () => {
  return (
    <>
      <style jsx>{`
        .wrapper {
          background-color: ${colors.white};
          padding: 10px 0 80px;
        }
        .container {
          max-width: 1000px;
          margin: 0 auto;
          padding: 0 10px;
        }
        .message-container {
          margin: 0 auto;
          max-width: 700px;
          text-align: center;
          padding: 60px 20px;
        }
        .message-title {
          font-size: 32px;
          font-weight: bold;
          margin-bottom: 30px;
          color: ${colors.defaultText};
        }
        .message-text {
          font-size: 18px;
          line-height: 1.8;
          color: ${colors.defaultText};
        }
        @media (max-width: 768px) {
          .message-title {
            font-size: 24px;
          }
          .message-text {
            font-size: 16px;
          }
        }
      `}</style>
      <Helmet>
        <title>Referral Recruiting Award 2025 エントリーフォーム｜Refcome</title>
        <meta name="description" content="Referral Recruiting Award 2025のエントリー受付は終了しました。" />
        <meta property="og:title" content="Referral Recruiting Award 2025 エントリーフォーム｜Refcome" />
        <meta property="og:description" content="Referral Recruiting Award 2025のエントリー受付は終了しました。" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://refcome.com/events/award/entry/2025" />
      </Helmet>
      <Layout>
        <div className="wrapper">
          <div className="container">
            <div className="message-container">
              <h1 className="message-title">Referral Recruiting Award 2025</h1>
              <p className="message-text">エントリー受付は終了いたしました。</p>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default ReferralRecruitingAward2025EntryPage;
